/* eslint-disable @typescript-eslint/no-unused-vars, no-param-reassign */

import {
  config,
  reducers,
  State as AuthState,
  setActions,
  saga as authSaga,
  updateConfig,
  getLocalState,
  Action,
  FETCH_ME_AFTER_SUCCESS_AUTHORIZATION, getState, UrlObject, PayloadAction, AnyObject, createUrl,
} from '@triare/auth-redux';
import { createSlice, SliceCaseReducers } from '@reduxjs/toolkit';
import {
  spawn, delay, takeLatest, put,
} from 'redux-saga/effects';
import { EnhancedStore } from '@reduxjs/toolkit/src/configureStore';
import { useSelector } from 'react-redux';
import { OTPResponse } from '@triare/auth-redux/dist/saga/auth/OTP';
import { userMe } from '@triare/auth-redux/dist/saga/auth/useMe';
import { SignInAction } from '@triare/auth-redux/dist/saga/auth/signIn';
import { signOut } from '@triare/auth-redux/dist/saga/auth/signOut';
import { RootState } from '../index';
import { UserRoles } from '../../enums/user';
import { UserRole, UserSimple, UserStatus } from '../../hooks/api/user';

export * from '@triare/auth-redux';

export default updateConfig({
  name: 'TGYM',
  displayName: 'TGYM',
  fetchDelay: parseInt(process.env.REACT_APP_FETCH_DELAY || '0', 10),
  api: {
    url: process.env.REACT_APP_API || '',
  },
  signIn: {
    ...config.signIn,
    requestBody: {
      byEmail: ({ remember, ...data }: SignInAction) => JSON.stringify(data),
      byUsername: ({ remember, ...data }: SignInAction) => JSON.stringify(data),
      byPhone: ({ remember, ...data }: SignInAction) => JSON.stringify(data),
      byService: ({ method, remember, ...data }: SignInAction) => JSON.stringify(data),
    },
    fetchMeAfterSuccess: FETCH_ME_AFTER_SUCCESS_AUTHORIZATION, // true
  },
  OTP: {
    ...config.OTP,
    fetchMeAfterSuccess: false,
  },
  createUrl: (
    url: string | UrlObject,
    addToUrl?: string,
    payload?: PayloadAction,
    data?: AnyObject,
    _query?: AnyObject,
  ) => createUrl(url, addToUrl, payload, data, {
    ..._query,
    lang: 'ru',
  }),
});

export const moduleName = config.auth.name;

export interface AuthUser {
  id: string;
  status: string;
  role: UserRole;
  name: string;
  email: string;
  subscription?: string;
}

export interface State extends AuthState {
  user: AuthUser | null
  secretKey: string
}

export function useAuthState(): State {
  return useSelector((state: RootState) => state[moduleName]);
}

export const auth = createSlice({
  name: moduleName,
  initialState: getLocalState(),
  reducers: {
    ...reducers,
    signInSuccess: (state, { payload }) => {
      state.signIn.loading = false;
      state.signIn.response = payload || null;
      state.authorized = !!(payload.access && payload.refresh);

      Object.assign(state, payload);

      if (payload?.remember !== undefined) {
        state.remember = payload?.remember;
      }
    },
    signUpFinish: (state, { payload }) => {
      state.signIn.loading = false;
      state.signIn.response = payload || null;
      state.authorized = true;

      Object.assign(state, payload);

      if (payload?.remember !== undefined) {
        state.remember = payload?.remember;
      }
    },
  },
});

export const { reducer, actions } = auth;

setActions(actions);

export function* saga(store: EnhancedStore) {
  yield spawn(authSaga, store);

  yield takeLatest(actions.OTPSuccess.type, function* trigger({ payload }: Action<OTPResponse>) {
    yield put({
      type: actions.signInSuccess.type,
      payload,
    });
  });

  // yield takeLatest(actions.userMeSuccess.type, function* trigger() {
  //   const authData = (yield getState()) as State;
  //
  //   if (authData && authData.user && authData.user.role === UserRoles.GUEST) {
  //     yield put(signOut());
  //
  //     window.location.href = '/sign-up';
  //   }
  // });
  //
  // yield takeLatest(actions.signUpFinish.type, function* trigger() {
  //   yield takeLatest(actions.userMeSuccess.type, function* userMeSuccess() {
  //     yield delay(250);
  //
  //     window.location.href = '/';
  //   });
  //
  //   yield put(userMe());
  // });
}
